//DECLARACION DE VENTAS ✅

export const salesStatementModule = {
    feature_code: 'FEAT-428',
    enabled: false,
}